import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import ExpandDiv from "../common/ExpandDiv";
import { residenceNotes } from "../services/soar";
import FloatingInput from "../common/FloatingInput";

function ApartmentNotes({ data, refreshData }) {
  const [noteData, setNoteData] = useState("");

  const addNote = async () => {
    const body = {
      command: "insert",
      application: data.application,
      residence: data.id,
      name: `${
        JSON.parse(localStorage.getItem("safyInfo")).user.displayName
      } - ${new Date().toLocaleDateString()}`,
      note: noteData,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };

    const response = await residenceNotes(body);
    if (response.code === "success") {
      toast.success(`Note Created Successfully`);
      setNoteData("");
      refreshData();
    } else {
      console.log("Error Response", response);
      toast.error(`Error Creating Note`);
    }
  };
  return (
    <ExpandDiv
      className={`border p-2 mb-2 card-safy`}
      title="Notes"
      expandStatus={true}
    >
      <div className="">
        <div className="row rounded border border-dark bg-light p-2 mx-2">
          {data.notes?.length > 0
            ? data.notes?.map((note, index) => (
                <div key={note.id} className="w-100 mb-4">
                  <div
                    className={`w-50 ${
                      note.created?.by?.toUpperCase() ===
                      JSON.parse(
                        localStorage.getItem("safyInfo")
                      ).user.azureId.toUpperCase()
                        ? "float-end"
                        : "float-start"
                    }`}
                  >
                    <div
                      className={`rounded border border-dark p-2 w-100 ${
                        note.created?.by?.toUpperCase() ===
                        JSON.parse(
                          localStorage.getItem("safyInfo")
                        ).user.azureId.toUpperCase()
                          ? "bg-primary text-white float-end"
                          : "bg-white text-dark"
                      }`}
                    >
                      {note.note}
                    </div>
                    <div
                      className={` ${
                        note.created?.by?.toUpperCase() ===
                        JSON.parse(
                          localStorage.getItem("safyInfo")
                        ).user.azureId.toUpperCase()
                          ? "float-end"
                          : ""
                      }`}
                    >
                      {`${note?.created?.name} - ${moment(
                        note?.created?.on
                      ).format("MM/DD/YY")}`}
                    </div>
                  </div>
                </div>
              ))
            : "No Notes Currently"}
        </div>
        <div className="row mt-4 mx-2">
          <div className="col-6"></div>
          <div className="col-6">
            <FloatingInput
              className="card-safy mb-2"
              label={<div className="text-danger">Note</div>}
              name="note"
              value={noteData}
              onChange={(e) => {
                setNoteData(e.target.value);
              }}
            />
            <div
              className="btn btn-primary float-end"
              onClick={() => addNote()}
            >
              Add Note
            </div>
          </div>
        </div>
      </div>
    </ExpandDiv>
  );
}

export default ApartmentNotes;
